const PATTERN = /\D/g;
export const getInputNumbersValue = (value: string) => {
  return value?.replace(PATTERN, '');
};

export const formedPhone = (phone: string): string => {
  try {
    if (!phone) {
      return '';
    }
    let value = getInputNumbersValue(phone);
    let formatValue;
    if (value[0] === '7' || value[0] === '8') {
      formatValue = '+7 ';
      if (value.length >= 1) {
        formatValue += '(' + value.substring(1, 4);
      }
    } else {
      value = '8' + value;
      formatValue = '+7 (' + value[1];
      if (value.length >= 1) {
        formatValue += value.substring(2, 4);
      }
    }
    if (value.length >= 5) {
      formatValue += ') ' + value.substring(4, 7);
    }
    if (value.length >= 8) {
      formatValue += '-' + value.substring(7, 9);
    }
    if (value.length >= 10) {
      formatValue += '-' + value.substring(9, 12);
    }

    return formatValue;
  } catch (error) {
    console.warn(error);
    return '';
  }
};

export const formatPhoneToApi = (phone: string) => {
  try {
    return phone?.replace(' (', '(')?.replace(') ', ')');
  } catch (e) {
    return phone;
  }
};
